// extracted by mini-css-extract-plugin
module.exports = {"root":"Arrow_root__3rqtS","up":"Arrow_up__1FOmb","down":"Arrow_down__3M4QM"};